import React from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'
import * as styles from './ProgressBar.module.scss'

const ProgressBar: React.FC = () => {
  const t = useIntl()
  const percentages = [
    { n: 0, label: 2 },
    { n: 10, label: 20 },
    { n: 20, label: 33 },
    { n: 30, label: 50 },
    { n: 40, label: 61 },
    { n: 50, label: 78 },
    { n: 60, label: 84 },
    { n: 70, label: 92 },
    { n: 80, label: 99 },
    { n: 90, label: 100 },
    { n: 100, label: 100 }
  ]

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <div className={styles.title}>
          <span
            className={styles.titleText}
          >
            {t.formatMessage({ id: 'levelup.progressbar-python' })}
          </span>
          <span
            className={styles.titleText}
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              animationName: styles.languageSecond
            }}
          >
            {t.formatMessage({ id: 'levelup.progressbar-js' })}
          </span>
          <span
            className={styles.titleText}
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              animationName: styles.languageThird
            }}
          >
            {t.formatMessage({ id: 'levelup.progressbar-java' })}
          </span>

        </div>
        <div className={styles.percentage}>
          {percentages.map(p => (
            <span
              key={p.n}
              className={styles.percent}
              style={{
                animationName: styles[`percent${p.n}`]
              }}
            >
              {p.label}%
            </span>
          ))}
          <span
            className={styles.percent}
            style={{
              animationName: styles.percentLow
            }}
          >
            0%
          </span>
        </div>
      </div>
      <div className={styles.bar}>
        <div
          className={styles.fill}
        />
      </div>
    </div>
  )
}

export default ProgressBar
